// Vue
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { AufbauplusHeadline } from "#/components/aufbauplus_headline/AufbauplusHeadline";
import ModuleBase from "#/common/ModuleBase";
import { Video } from "@mgs/ci2019-common/src/components/shared/video/Video";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    AufbauplusHeadline,
    Video,
  },
})
export class TypeB extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get videoUrl() {
    if (
      this.instance &&
      this.instance["section_image"] &&
      this.instance["section_image"]["video"] &&
      this.instance["section_image"]["video"]["embedUrl"]
    ) {
      return this.instance["section_image"]["video"]["embedUrl"];
    } else if (
      this.instance &&
      this.instance["section_image"] &&
      this.instance["section_image"]["video"] &&
      this.instance["section_image"]["video"]["uploadUrl"]
    ) {
      return this.instance["section_image"]["video"]["uploadUrl"];
    } else {
      return null;
    }
  }

  get posterUrl() {
    if (
      this.videoUrl &&
      this.instance &&
      this.instance["section_image"] &&
      this.instance["section_image"]["image"] &&
      this.instance["section_image"]["image"][this.lang]
    ) {
      return this.getTranslatedImage(
        this.instance["section_image"]["image"],
        this.lang,
        "large"
      );
    } else {
      return null;
    }
  }

  get imageMobile() {
    if (this.videoUrl) {
      return null;
    } else {
      if (
        this.instance &&
        this.instance["section_image"] &&
        this.instance["section_image"]["image_mobile"] &&
        this.instance["section_image"]["image_mobile"][this.lang]
      ) {
        return this.getTranslatedImage(
          this.instance["section_image"]["image_mobile"],
          this.lang,
          "large"
        );
      } else if (
        this.instance &&
        this.instance["section_image"] &&
        this.instance["section_image"]["image"] &&
        this.instance["section_image"]["image"][this.lang]
      ) {
        return this.getTranslatedImage(
          this.instance["section_image"]["image"],
          this.lang,
          "large"
        );
      } else {
        return null;
      }
    }
  }

  get imageDesktop() {
    if (this.videoUrl) {
      return null;
    } else {
      if (
        this.instance &&
        this.instance["section_image"] &&
        this.instance["section_image"]["image"] &&
        this.instance["section_image"]["image"][this.lang]
      ) {
        return this.getTranslatedImage(
          this.instance["section_image"]["image"],
          this.lang,
          "xlarge"
        );
      } else {
        return null;
      }
    }
  }

  get headlineBackgroundColor() {
    return this.backgroundColor == "black" ? "black" : "white";
  }

  get columnSizeHeadline() {
    return 12 - this.columnSizeImage;
  }

  get columnSizeImage() {
    return parseInt(
      this.instance["section_position_columns"]["column_size_image"],
      10
    );
  }

  get columnSizeText() {
    return parseInt(
      this.instance["section_position_columns"]["column_size_text"],
      10
    );
  }

  get columnTextOffsetClass() {
    let size = 12 - this.columnSizeText;
    if (this.instance["section_position_columns"]["position"] == "left") {
      return `offset-md-${size}`;
    } else {
      return "";
    }
  }

  get imagePositionClass() {
    return `${this.$appPrefix}-aufbauplus-text-bild-module--position-${this.instance["section_position_columns"]["position"]}`;
  }

  get imageCaptionOffsetClass() {
    let size = this.columnSizeText;
    if (this.instance["section_position_columns"]["position"] == "right") {
      return `image-caption-offset-${this.columnSizeText}-${this.columnSizeImage}`;
    } else {
      return `image-caption-suffix-${this.columnSizeText}-${this.columnSizeImage}`;
    }
  }

  get isOverlapping() {
    return this.columnSizeImage + this.columnSizeText > 12;
  }

  get isOverlappingClass() {
    return this.isOverlapping
      ? `${this.$appPrefix}-aufbauplus-text-bild-module--overlapping`
      : `${this.$appPrefix}-aufbauplus-text-bild-module--no-overlapping`;
  }

  get hasImageClass() {
    if (this.imageDesktop || this.videoUrl) {
      return `${this.$appPrefix}-aufbauplus-text-bild-module--with--image`;
    } else {
      return `${this.$appPrefix}-aufbauplus-text-bild-module--no--image`;
    }
  }
}
